import axios from 'axios';
import { authService } from './authService';
import { API_CONFIG } from '../appConfig';

// Déterminer si nous sommes en mode développement
const isDevelopment = process.env.NODE_ENV === 'development';

const baseURL = `${API_CONFIG.baseURL}:${API_CONFIG.port}/${API_CONFIG.basePath}`;
const stripeURL = `${API_CONFIG.stripeURL}`;
const apiClient = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
  withCredentials: false,
});

/*
const stripeApiClient = axios.create({
  baseURL: stripeURL,
  headers: {
    'Authorization': `Bearer ${process.env.REACT_APP_STRIPE_SECRET_KEY}`,
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  withCredentials: false,
});*/

const baseURLv1 = `${API_CONFIG.baseURL}:${API_CONFIG.port}/${API_CONFIG.versionPath}`;
const apiClientv1 = axios.create({
  baseURL:baseURLv1,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
  withCredentials: false,
});

apiClient.interceptors.request.use((config) => {
  console.log('Request made with ', config);
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
apiClientv1.interceptors.request.use((config) => {
  console.log('Request made with ', config);
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Error response: ', error);
    if (error.response?.status === 401) {
      authService.logout();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
apiClientv1.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Error response: ', error);
    if (error.response?.status === 401) {
      authService.logout();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export { apiClientv1 };
  
export default apiClient;